import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"

//dashboard

import StudentDetails from "./students/reducer"

import StudentDashboard from "./studentDashboard/reducer"
import ChatDetails from "./chat/reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  StudentDetails,
  StudentDashboard,
  ChatDetails,
})

export default rootReducer
